import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { toggleALertNote } from '../../redux/actions/cm/alertDetails';

import {
  ADD_ALERT_NOTE,
  addAlertNoteSuccess,
  addAlertNoteFail,
  FETCH_ALERT_NOTE_HISTORY,
  fetchAlertNoteHistorySuccess,
  fetchAlertNoteHistoryFail
} from '../../redux/actions/cm/alertNote';

import { addAlertNote } from '../../services/cm/alerts';
import { fetchHistoryForAlert } from '../../services/cm/historyItems';

function* addAlertNoteWorker({ alertId, alertNote }) {
  try {
    yield call(addAlertNote, { alertId, alertNote });
    yield put(addAlertNoteSuccess());
    yield put(toggleALertNote({ isOpen: false }));
  } catch (error) {
    yield put(addAlertNoteFail());
  }
}

export function* watchAddAlertNote() {
  yield takeEvery(
    ADD_ALERT_NOTE,
    function* ({ payload: { alertId, alertNote } }) {
      yield fork(addAlertNoteWorker, { alertId, alertNote });
    }
  );
}

function* fetchAlertNoteHistoryWorker({ alertId }) {
  try {
    // FIN-9812: Fetch both ADD_NOTE and CHANGE_STATUS to show status transitions in alert notes
    const { items } = yield call(fetchHistoryForAlert, {
      alertId
    });
    yield put(
      fetchAlertNoteHistorySuccess({ list: items, total: items.length })
    );
  } catch (error) {
    yield put(fetchAlertNoteHistoryFail());
  }
}

export function* watchfetchAlertNoteHistory() {
  yield takeEvery(
    FETCH_ALERT_NOTE_HISTORY,
    function* ({ payload: { alertId } }) {
      yield fork(fetchAlertNoteHistoryWorker, { alertId });
    }
  );
}
